import React, { useState, useEffect } from "react";
import { Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Target your scrollable container
    const container =
      document.querySelector(".form-wrapper") ||
      document.querySelector(".upload-document-wrapper") ||
      document.querySelector("body"); // <-- change to your container's class or id

    if (!container) return;

    const toggleVisibility = () => {
      setVisible(container.scrollTop > 100);
    };

    container.addEventListener("scroll", toggleVisibility);
    return () => container.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    const container =
      document.querySelector(".form-wrapper") ||
      document.querySelector(".upload-document-wrapper") ||
      document.querySelector("body");
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      {visible && (
        <Fab
          color="default"
          size="small"
          onClick={scrollToTop}
          sx={{
            position: "absolute",
            right: 20,
            bottom: "80px",
            backgroundColor: "#f4f2f7",
            borderRadius: 2,
            "&:hover": { backgroundColor: "#e0e0e0" },
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      )}
    </>
  );
}
